// This file is regenerated each time the app is run using the version value in package.json.var APP_VERSION = '1.6.0';
